/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  
    
  })();

/* Functionality to open drawer on related/recent viewed section */
function mkc_serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf('[');

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === '' || formElement.disabled) {
        continue;
      }

      if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = mkc_extend(hash, stringKeys);
      }
    }

        return hash;
}


function mkc_extend() {
        var extended = {};
        var i = 0;

        // Merge the object into the extended object
        var merge = function merge(obj) {
          for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
              // If property is an object, merge properties
              if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                extended[prop] = Form.extend(extended[prop], obj[prop]);
              } else {
                extended[prop] = obj[prop];
              }
            }
          }
        };

        // Loop through each object and conduct a merge
        for (; i < arguments.length; i++) {
          merge(arguments[i]);
        }

        return extended;
}

function mkc_addToCart(event) {
    
        var _this8 = this;

        var is_related = 'related';
  
        this.element = event.target.closest('form');


        if(this.element.classList.contains('recent-viewed')){
            is_related = 'recent';
        }


        event.preventDefault(); // Prevent form to be submitted

        var addToCartButton = this.element.querySelector('.ProductForm__AddToCart');

        // First, we switch the status of the button
        addToCartButton.setAttribute('disabled', 'disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        // Then we add the product in Ajax
        var formElement = this.element;

        fetch('/cart/add.js', {
          body: JSON.stringify(mkc_serialize(formElement)),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          if (response.ok) {
            addToCartButton.removeAttribute('disabled');
            // We simply trigger an event so the mini-cart can re-render
            _this8.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                sku: formElement.querySelector('[name="id"]').getAttribute("data-sku"),
                variant: formElement.querySelector('[name="id"]').value,
                quantity: parseInt(formElement.querySelector('[name="quantity"]').value),
                related: is_related
              }
            }));
          } else {
            response.json().then(function (content) {
              var errorMessageElement = document.createElement('span');
              errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
              errorMessageElement.innerHTML = content['description'];
              addToCartButton.removeAttribute('disabled');
              addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
              setTimeout(function () {
                errorMessageElement.remove();
              }, 2500);
            });
          }
        });

        event.preventDefault();
}

/* end of functionality to open drawer on related/recent viewed section */

/* Events Tracking GA */
function onRelatedProductClick(event) {      
  if (window.ga && window.ga.loaded && typeof window.ga.getAll === 'function') {
    var trackerSend = 'send';
    trackerSend = window.ga.getAll().reduce(function (acc, tracker) {
        var thisTrackerId = tracker.get('trackingId');
        acc = tracker.get('name') + '.send';       
        return acc;
      }, 'send');

    window.ga('require', 'ec');
    window.ga(trackerSend, 'event', {
            eventCategory: 'Related Products',
            eventAction: 'Added Product - Related Products',
            eventLabel: event.detail.sku
        });
    } 
}
function onViewRelatedProductClick(event) {      
    if (window.ga && window.ga.loaded && typeof window.ga.getAll === 'function') {
      var trackerSend = 'send';
      trackerSend = window.ga.getAll().reduce(function (acc, tracker) {
          var thisTrackerId = tracker.get('trackingId');
          acc = tracker.get('name') + '.send';       
          return acc;
        }, 'send');
  
      window.ga('require', 'ec');
      window.ga(trackerSend, 'event', {
              eventCategory: 'Related Products',
              eventAction: 'View Product - Related Products',
              eventLabel: event.target.getAttribute("data-sku")
          });
      } 
  }
function onRecentViewedProductClick(event) {
    if (window.ga && window.ga.loaded && typeof window.ga.getAll === 'function') {
        var trackerSend = 'send';
        trackerSend = window.ga.getAll().reduce(function (acc, tracker) {
            var thisTrackerId = tracker.get('trackingId');
            acc = tracker.get('name') + '.send';       
            return acc;
          }, 'send');
    
        window.ga('require', 'ec');
        window.ga(trackerSend, 'event', {
            eventCategory: 'Recent Viewed Products',
            eventAction: 'Added Product - Recent Viewed Products',
            eventLabel: event.detail.sku
          });
        }     
}
function onViewRecentViewedProductClick(event) {
    if (window.ga && window.ga.loaded && typeof window.ga.getAll === 'function') {
        var trackerSend = 'send';
        trackerSend = window.ga.getAll().reduce(function (acc, tracker) {
            var thisTrackerId = tracker.get('trackingId');
            acc = tracker.get('name') + '.send';       
            return acc;
          }, 'send');
    
        window.ga('require', 'ec');
        window.ga(trackerSend, 'event', {
            eventCategory: 'Recent Viewed Products',
            eventAction: 'View Product - Recent Viewed Products',
            eventLabel: event.target.getAttribute("data-sku")
          });
        }     
}
/* end of Events Tracking GA */

jQuery(document).ready(function($) {
    $(document).on('click','.ProductForm__AddToCart.related--button',function(event) {
        mkc_addToCart(event);
    });
    $(document).on('click','a.related-view',function(event) {
        onViewRelatedProductClick(event);
    });
    $(document).on('click','a.recent-viewed',function(event) {
        onViewRecentViewedProductClick(event);
    });
});

document.addEventListener('product:added', function(event) {
    var is_related = event.detail.related;
    if( is_related == "related" ){
        onRelatedProductClick(event);
    }
    if( is_related == "recent" ){
        onRecentViewedProductClick(event);
    }
});

jQuery(window).scroll(function() {
  scroll = jQuery(window).scrollTop();
  if (scroll >= 1) {
    jQuery('.shopify-section--header').addClass('mkc-sticky');
  } else {
    jQuery('.shopify-section--header').removeClass('mkc-sticky');
  }
});

document.addEventListener('click', (e) => {
     var origupselladdToCart = window.upsell.addToCart;
    if (e.target.classList.contains('upsell-addToCart')) {
      //e.stopPropagation();
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      var origupselladdToCart = window.upsell.addToCart;
      window.upsell.addToCart = function(n,o,a,i,r,l){

          var addData = {
            'id':n, 
            'quantity':1
          };

          fetch('/cart/add.js', {
            body: JSON.stringify(addData),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (response) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            if (response.ok) {
              e.target.removeAttribute('disabled');
              // We simply trigger an event so the mini-cart can re-render
              e.target.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant:n,
                  quantity: 1,
                  related: 0
                }
              }));
            } 
          });

          e.preventDefault();
      }     
      
    }
}, true);


      
